"use client";

import React from "react";

export interface Benefit {
  icon: React.ReactNode;
  title: string;
  description: string;
  highlight?: string;
}

export interface BenefitsGridProps {
  title: string;
  benefits: Benefit[];
  columns?: 1 | 2 | 3 | 4;
  bgColor?: string;
}

export function BenefitsGrid({
  title,
  benefits,
  columns = 2,
  bgColor = "bg-gray-50"
}: BenefitsGridProps) {
  const gridCols = {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4"
  };

  return (
    <section className={`py-16 md:py-20 ${bgColor}`}>
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
          {title}
        </h2>
        <div className={`grid ${gridCols[columns]} gap-8`}>
          {benefits.map((benefit, idx) => (
            <div key={idx} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-primary-100 rounded-xl flex items-center justify-center mb-6">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {benefit.description}
              </p>
              {benefit.highlight && (
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span>{benefit.highlight}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}